import { Form } from "react-bootstrap";

const SUBSCRIPTION_TYPES = ["Trial", "Standard", "Premium", "Enterprise"];
const SUBSCRIPTION_STATUSES = ["Active", "Expired", "Cancelled"];

function CustomerAccountsToolbar({
  search,
  onSearchChange,
  status,
  onStatusChange,
  subscription,
  onSubscriptionChange,
  subscriptionStatus,
  onSubscriptionStatusChange,
}) {
  return (
    <div className="premium-filter-card customer-toolbar">
      <div className="search-top-right">
        <i className="fa fa-search" aria-hidden="true"></i>
        <Form.Control
          placeholder="Search by name or account code…"
          value={search}
          onChange={(e) => onSearchChange(e.target.value.trim() !== "" ? e.target.value : "")}
        />
      </div>
      <select
        className="filter-select"
        aria-label="Subscription"
        value={subscription}
        onChange={(e) => onSubscriptionChange(e.target.value)}
      >
        <option value="">Subscription</option>
        {SUBSCRIPTION_TYPES.map((type) => (
          <option key={type} value={type}>
            {type}
          </option>
        ))}
      </select>
      <select
        className="filter-select"
        aria-label="Status"
        value={status}
        onChange={(e) => onStatusChange(e.target.value)}
      >
        <option value="">Status</option>
        <option value="active">Active</option>
        <option value="inactive">Deactivated</option>
      </select>
      <select
        className="filter-select"
        aria-label="Subscription Status"
        value={subscriptionStatus}
        onChange={(e) => onSubscriptionStatusChange(e.target.value)}
      >
        <option value="">Subscription Status</option>
        {SUBSCRIPTION_STATUSES.map((value) => (
          <option key={value} value={value}>
            {value}
          </option>
        ))}
      </select>
    </div>
  );
}

export default CustomerAccountsToolbar;
